const toBool = (val: string | undefined): boolean | undefined =>
  val === 'true' ? true : val === 'false' ? false : undefined;

// Main streaming-transcription provider for every modality (video, phone,
// clinic, dictation). Default 'aws'; set VITE_TRANSCRIPTION_PROVIDER=deepgram
// to switch the whole app to Deepgram nova-3-medical.
const toTranscriptionProvider = (val: string | undefined): 'aws' | 'deepgram' =>
  val === 'deepgram' ? 'deepgram' : 'aws';

const config = {
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT as string,
  API_URL: import.meta.env.VITE_API_URL as string,
  PROTOCOL: import.meta.env.VITE_PROTOCOL as string,
  REFERRAL_REQUEST: toBool(import.meta.env.VITE_REFERRAL_REQUEST),
  CAREY_ENABLED: toBool(import.meta.env.VITE_CAREY_ENABLED),
  MATOMO_ENABLED: toBool(import.meta.env.VITE_MATOMO_ENABLED),
  GOOGLE_TAG_ID: import.meta.env.VITE_GOOGLE_TAG_ID as string | undefined,
  FACEBOOK_PIXEL: import.meta.env.VITE_FACEBOOK_PIXEL as string | undefined,
  TRANSCRIPTION_PROVIDER: toTranscriptionProvider(import.meta.env.VITE_TRANSCRIPTION_PROVIDER),
};

export default config;

export const {
  ENVIRONMENT,
  API_URL,
  PROTOCOL,
  REFERRAL_REQUEST,
  CAREY_ENABLED,
  MATOMO_ENABLED,
  GOOGLE_TAG_ID,
  FACEBOOK_PIXEL,
  TRANSCRIPTION_PROVIDER,
} = config;
